module.exports = __webpack_public_path__ + "img/ruku.890b8249.png";